import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import NewsCard from '../../../News/components/NewsCard'

import http from '../../../../../../shared/http'
import eventEmitter, { types } from '../../../../../../shared/eventEmitter'
import { TApi, TRoles, TRoutes } from '../../../../../../shared/const'

import styles from './style.module.scss'

/*
 * Veranstaltungen & Neuigkeiten neben den Mitteilungen.
 *
 * Beides sind Nachrichten an dieselbe Person, aber von verschiedener Art: Die
 * Mitteilung betrifft die eigene Junior Company und will bearbeitet werden,
 * die Neuigkeit ist ein Angebot und will gelesen werden. Nebeneinander gestellt
 * bleibt jede erkennbar — untereinander in einer Liste ginge das Angebot
 * zwischen den Aufgaben unter.
 *
 * Die Spalte ist ein Auszug, keine zweite Ansicht: Sie zeigt die neuesten
 * Karten und verweist auf die vollstaendige Seite. Was der Server liefert,
 * laeuft ohnehin gerade — vergangene Veranstaltungen kommen nicht mit.
 */

const LIMIT = 6

export default function NewsAside(props) {
	const { t } = useTranslation()
	const [news, setNews] = useState([])
	const [count, setCount] = useState(0)
	const [isLoading, setLoading] = useState(true)

	// Wie in der Mitteilungsliste: Nach einem Neuladen schiebt App.js auf das
	// Dashboard, waehrend die Abfrage noch laeuft.
	const isMounted = useRef(true)

	useEffect(() => () => (isMounted.current = false), [])

	useEffect(() => {
		const url = props.role === TRoles.TEACHER ? TApi.TEACHER_GET_NEWS : TApi.STUDENT_GET_NEWS

		setLoading(true)
		http.get(url, {
			params: {
				limit: LIMIT,
				offset: 0,
				order: 'startDate',
				direction: 'desc',
				filter: JSON.stringify({})
			}
		})
			.then(({ data }) => {
				if (!isMounted.current) return
				setNews(data.rows)
				setCount(data.count)
			})
			.finally(() => isMounted.current && setLoading(false))
	}, [props.role])

	return (
		<aside className={styles.root}>
			<div className={styles.head}>
				<h4 className={styles.title}>{t('Events & News')}</h4>
				{count > 0 && (
					<Link to={TRoutes.NEWS} className={styles.all}>
						{t('Show all')} ({count})
					</Link>
				)}
			</div>

			{!isLoading && !news.length && <p className={styles.empty}>{t('No news yet')}</p>}

			<div className={styles.list}>
				{news.map(item => (
					<NewsCard
						key={item.id}
						item={item}
						onOpen={feed => eventEmitter.emit(types.openDetailFeedModal, feed)}
					/>
				))}
			</div>
		</aside>
	)
}

NewsAside.propTypes = {
	role: PropTypes.string.isRequired
}
